import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { TableTooltip } from '~src/spacesPlatform/components/tooltip/TableTooltip';
import { doesTooltipNotHaveOwnerToDisplay } from '~src/spacesPlatform/components/tooltip/Tooltip';
import { TooltipAnchor } from '~src/spacesPlatform/components/tooltip/TooltipAnchor';
import { getCommonTableInfo, getGraphQLId, isContentInfoTable } from '~src/spacesPlatform/models/CommonTableInfo';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

import { TableThumbnail } from './TableThumbnail';


export class TableCard extends ContentCard {

    public render() {
        const content = this.props.content;
        const commonTable = getCommonTableInfo(content);
        const disableAutoFocus = doesTooltipNotHaveOwnerToDisplay(content);
        const contentUrl = getTableContentUrl(this.props.urls, this.props.content);
        return (
            <div className={CardViewStyles.Card}>
                <TooltipAnchor disableAutoFocus={disableAutoFocus}
                               disableTooltip={this.props.disableTooltip}
                               onShowTooltip={this.handleShowTooltip}
                               title={Messages.tableDetails()}
                               tooltipContent={this.renderTooltipContent}
                               width={DetailsTooltipStyles.Width}>
                    <TableThumbnail allowDragAndDrop={this.props.allowDragAndDrop}
                                       content={commonTable}
                                       contentUrl={contentUrl}
                                       hoveredOrSelected={this.props.hoveredOrSelected}
                    />
                </TooltipAnchor>
                <div className={CardViewStyles.ActionRow}>
                    <span data-tb-test-id="table-name" className={CardViewStyles.ActionRowName} title={content.name}>
                        {content.name}
                    </span>
                    {this.renderActionsMenu()}
                </div>
                <div className={CardViewStyles.CardDescription}>
                    {this.getDescription()}
                </div>
            </div>
        );
    }

    private renderTooltipContent = () => {
        return <TableTooltip content={this.props.content}
                            urls={this.props.urls}/>;
    };
}

export function getTableContentUrl(urls: SpacesSiteUrls, content: IContentInfo): string {
    if (isContentInfoTable(content)) {
        const contentId = getGraphQLId(content);
        return urls.catalogTableUrl(contentId);
      }

    return getContentUrlForItem(content, urls);
}